import tasks from '../../fields/shared/tasks';

export const QUERY_GET_ALL_TASKS = /* GraphQL */ `
	query($limit: Float, $offset: Float, $filter: TaskFilter, $notEqual: TaskFilter) {
		getAllTasks(
			limit: $limit
			offset: $offset
			filter: $filter
			notEqual: $notEqual
		) {
			items {
				${tasks}
				subTasks {
					${tasks}
				}
			}
			total
		}
	}
`;
